import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const YearInfo = Loadable({
  loader: () => import("./components/year-info"),
  loading: Loading
});

export const routes = [
  {
    path: '/year-info',
    exact: true,
    name: 'year-info',
    component: YearInfo,
    // "permission": {
    //   "contactype": [
    //     "affiliate"
    //   ],
    //   "group": [
    //     "Staff Carers"
    //   ]
    // }
  }
];